<template>
<v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">SETUP</div>
                        <div class="text-h6 font-weight-bold primary--text">Grading</div>
                        <div class="text-body-2 grey--text">Set your school results grading system</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- Create /Update Form -->
                        <v-col cols="12" v-if="newform">
                            <v-form v-model="valid" ref="form">
                                <v-container>
                                    <v-row>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        >
                                            <v-select
                                                v-model="form.grade"
                                                outlined
                                                :items="grades"
                                                :rules="[v => !!v || 'Grade Letter is required']"
                                                label="Pick a Grade Letter"
                                                prepend-inner-icon="mdi-alpha-a-circle-outline"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        >
                                            <v-text-field
                                                outlined
                                                v-model="form.lower_limit"
                                                label="Lower Limit"
                                                :rules="limitRules"
                                                type="number" onwheel="this.blur()"
                                                min="0"
                                                prepend-inner-icon="mdi-arrow-down-bold-box-outline"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="4"
                                        >
                                            <v-text-field
                                                outlined
                                                v-model="form.upper_limit"
                                                label="Upper Limit"
                                                :rules="limitRules"
                                                type="number" onwheel="this.blur()"
                                                min="0"
                                                prepend-inner-icon="mdi-arrow-up-bold-box-outline"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="12"
                                        >
                                            <v-text-field
                                                outlined
                                                v-model="form.remarks"
                                                label="Grading Remarks"
                                                prepend-inner-icon="mdi-comment-text-outline"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="12"
                                        >
                                        <v-btn :disabled="!valid" color="primary" rounded elevation="2"
                                        class="font-weight-bold text-none mr-3" @click="postRecord" v-if="!editBtn"
                                        >
                                            Create
                                            <v-icon right>mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn :disabled="!valid" color="primary" rounded elevation="2"
                                        class="font-weight-bold text-none mr-3" @click="updateRecord" v-else
                                        >
                                            Update
                                            <v-icon right>mdi-check</v-icon>
                                        </v-btn>
                                        <v-btn text color="secondary" class="text-none" @click="newform = false">
                                            <v-icon left>mdi-arrow-left</v-icon>
                                            Go Back
                                        </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-form>
                        </v-col>
                        <!-- Records -->
                        <v-col cols="12" v-else>
                            <info-loader-2 v-if="fetchingContent"/>
                            <v-row class="mb-5" v-else>
                                <v-col cols="12" sm="4" md="3" lg="2" v-for="(record, i) in records" :key="i">
                                    <v-card elevation="2" class="rounded-lg grade-card text-center pa-4">
                                        <div class="grade-badge mx-auto mb-2">{{record.grade}}</div>
                                        <div class="text-caption grey--text">{{record.lower_limit}} - {{record.upper_limit}}</div>
                                        <v-card-actions class="justify-center">
                                            <!-- <v-btn @click="editRecord(record)" fab light x-small
                                            ><v-icon dark> mdi-pencil </v-icon>
                                            </v-btn> -->
                                            <v-btn @click="deleteRecord(record)" icon color="error" small
                                            ><v-icon small> mdi-trash-can-outline </v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-btn outlined rounded color="primary" class="font-weight-bold text-none" @click="reset">
                                <v-icon left>mdi-plus</v-icon>
                                Add New Grade
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import HeaderVue from '../../components/Header.vue'
import InfoLoader2 from '../../components/InfoLoader2.vue';
  export default {
    name: 'Grades',
    components: {
        HeaderVue,
        InfoLoader2
    },
    mounted() {
       if (!this.authToken) {
            this.$router.push({name: 'Login'})
       }
       this.getRecords()
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        newform: false,
        editBtn: false,
        form:{},
        records:[],
        grades:['A+','A','B','C','D','E','F','P'],
        valid: true,
        limitRules: [
            v => !!v || 'Limit is required',
            v => /\b([0-9]|[1-9][0-9]|100)\b/.test(v) || 'Must be a valid integer',
        ],
        fetchingContent:true
    }),
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        reset () {
            this.newform = true
            this.form = {}
        },
        getRecords () {
            axios.get(process.env.VUE_APP_BASEURL+'/grades?school_id='+this.school.school_id,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.records =  response.data.data
                this.fetchingContent = false;
            })
            .catch((error) => {
                if (error.response?.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                this.fetchingContent = false;
            });
        },
        postRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_BASEURL+'/grades?school_id='+this.school.school_id,this.form,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                this.getRecords()
                this.newform = false
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        editRecord (record){
            this.newform = true
            this.form.id = record.grade_id
            this.form.grade = record.grade
            this.form.lower_limit = record.lower_limit
            this.form.upper_limit = record.upper_limit
            this.form.remarks = record.remarks
            this.editBtn = true
        },
        updateRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.put(process.env.VUE_APP_BASEURL+'/grades/'+this.form.id+'?school_id='+this.school.school_id,this.form,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                this.getRecords()
                this.editBtn = false
                this.newform = false
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        deleteRecord (record) {
            if(confirm("Do you really want to delete?")){
                let loader = this.$loading.show()
                axios.delete(process.env.VUE_APP_BASEURL+'/grades/'+record.grade_id+'?school_id='+this.school.school_id+'&confirm=DELETE',{
                    headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
                })
                .then(response => {
                     this.$toast.success(response.data.message, {
                        timeout: 5000
                    });
                    this.getRecords()
                })
                .catch(error => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            }
        }
    },
  }
</script>

<style scoped>
.grade-card {
    border: 1px solid #ECEFF7;
}
.grade-badge {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    font-weight: 800;
    color: #fff;
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
</style>
